import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, FormGroup, Label, Input } from "reactstrap";

export default function MedicalHistorySection({
  setFieldValue,
  medicalHistory,
  viewOnly
}) {
  const [formData, setFormData] = useState({});
  //     {
  //     diabetes: { hasCondition: "", details: "" },
  //     hypertension: { hasCondition: "", details: "" },
  //     cholesterol: { hasCondition: "", details: "" },
  //     thyroid: { hasCondition: "", details: "" },
  //     otherConditions: "",
  //     historyOfSurgeries: "",
  //     regularMedications: "",
  //   }
  const { settings } = useSelector((state) => state.gym.gym);
  const [yesNoFields, setYesNoFileds] = useState([]);
  const [textOnlyFields, setTextOnlyFileds] = useState([]);

  useEffect(() => {
    if (
      settings?.memberRegistration?.fields?.medicalHistory?.medicalConditionList
    ) {
      setYesNoFileds(
        settings?.memberRegistration?.fields?.medicalHistory?.medicalConditionList.map(
          (condition) => ({
            key: condition,
            label: condition,
          })
        )
      );
    }
    if (settings?.memberRegistration?.fields?.medicalHistory?.enabled) {
      const fields = settings.memberRegistration.fields.medicalHistory.fields;
      console.log(fields);

      const enabledTextFields = Object.entries(fields)
        .filter(([key, field]) => field?.enabled) // only enabled ones
        .map(([key]) => ({
          key: key,
          label: key
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (t) => t.toUpperCase()),
        }));

      setTextOnlyFileds(enabledTextFields);
    }
  }, [settings]);

  useEffect(() => {
    if (medicalHistory && Object.keys(medicalHistory).length > 0) {
      setFormData(medicalHistory);
    }
  }, [medicalHistory, yesNoFields, textOnlyFields]);
  const handleRadioChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        hasCondition: value,
        details: value === "no" ? "" : prev[key]?.details || "",
      },
    }));
  };

  const handleDetailsChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: { ...prev[key], details: value },
    }));
  };

  const handleTextChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  useEffect(() => {
    setFieldValue("medicalHistory", formData);
  }, [formData, setFieldValue]);
  return (
    <div className="mt-3">
      {/* YES/NO FIELDS WITH DETAILS IN ONE ROW */}
      {yesNoFields.map((field) => (
        <Row
          key={field.key}
          className="g-3 mb-3 align-items-center pl-2"
          style={{ height: "50px" }}
        >
          <Col md={3}>
            <Label className="fw-semibold mb-0" style={{ fontSize: "14px" }}>
              {field.label}
            </Label>
          </Col>
          {console.log(formData)}
          <Col md={2}>
            <div className="d-flex gap-3">
              <FormGroup check className="mb-0 mr-3">
                <Input
                  type="radio"
                  name={field.key}
                  value="yes"
                  id={`${field.key}-yes`}
                  checked={
                    formData[field.key] &&
                    formData[field.key]?.hasCondition === "yes"
                  }
                  onChange={(e) => handleRadioChange(field.key, e.target.value)}
                  className="mr-1"
                  disabled={viewOnly}
                />
                <Label check htmlFor={`${field.key}-yes`}>
                  Yes
                </Label>
              </FormGroup>

              <FormGroup check className="mb-0">
                <Input
                  type="radio"
                  name={field.key}
                  value="no"
                  id={`${field.key}-no`}
                  checked={
                    formData[field.key] &&
                    formData[field.key]?.hasCondition === "no"
                  }
                  onChange={(e) => handleRadioChange(field.key, e.target.value)}
                  disabled={viewOnly}
                />
                <Label check htmlFor={`${field.key}-no`}>
                  No
                </Label>
              </FormGroup>
            </div>
          </Col>

          <Col md={7}>
            {formData[field.key]?.hasCondition === "yes" && (
              
                viewOnly && !formData[field.key]?.details ? null
                :
              
              <Input
                type="textarea"
                value={formData[field.key]?.details}
                onChange={(e) => handleDetailsChange(field.key, e.target.value)}
                placeholder="Enter details..."
                disabled={viewOnly}
              />
            )}
          </Col>
        </Row>
      ))}

      {/* TEXT-ONLY FIELDS */}
      <Row className="g-3 mt-3 pt-3 ">
        {textOnlyFields.map((field) => (
          <Col key={field.key} md={12}>
            <FormGroup className="custom-inputs mb-3">
              <Input
                type="textarea"
                value={formData[field.key]}
                onChange={(e) => handleTextChange(field.key, e.target.value)}
                placeholder={viewOnly && !formData[field.key]?"N/A":field.label}
                className="form-control"
                disabled={viewOnly}
              />
              <Label>{field.label}</Label>
            </FormGroup>
          </Col>
        ))}
      </Row>
    </div>
  );
}
